export interface CompactSettings {
    databaseName: string;
    documents?: boolean;
    indexes?: string[];
    skipOptimizeIndexes?: boolean;
}
